import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Col, Collapse, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { modelOf } from '../../../prop-types';
import CustomerUserStore from '../../../store/CustomerUserStore';
import globalTranslations from '../../../i18n/globalTranslations';
import UIStore from '../../../store/UIStore';
import PurchaseTotal from '../PurchaseTotal';
import { paramsToQueryIdentifier } from '../../../util/query';
import { createHashTab } from '../../common/HashTabs';
import PurchaseProductList from '../PurchaseProductList';
import PurchaseTabTitle from '../PurchaseTabTitle';

@observer
export class PurchaseList extends Component {
  state = {
    activeTabId: null,
  };

  getQueryIdentifier = (searchParams) => {
    return paramsToQueryIdentifier(searchParams);
  };

  renderHeaders = () => {
    return (
      <div className="PurchaseList__headers">
        <Row>
          <Col md="4">
            <FormattedMessage {...globalTranslations.purchaseUserHeader} />
          </Col>
          <Col md="2">
            <FormattedMessage
              {...globalTranslations.purchaseOrderCountHeader}
            />
          </Col>
          <Col md="3">
            <FormattedMessage {...globalTranslations.purchaseWithVatHeader} />
          </Col>
          <Col md="3">
            <FormattedMessage
              {...globalTranslations.purchaseWithoutVatHeader}
            />
          </Col>
        </Row>
      </div>
    );
  };

  setActiveId = (id) => {
    this.setState({
      activeTabId: id,
    });
  };

  getActiveId = () => {
    return this.state.activeTabId;
  };

  toggleTab = (tabId) => {
    if (this.state.activeTabId !== tabId) {
      this.setActiveId(tabId);
    } else {
      this.setActiveId(null);
    }
  };

  getTabs = () => {
    const { customerUserStore, searchParams } = this.props;
    const tabs = [];

    customerUserStore.purchaseQueryResults
      .get(this.getQueryIdentifier(searchParams))
      .purchases.map((purchase) =>
        tabs.push(
          createHashTab(
            purchase.user_id.toString(),
            <PurchaseTabTitle
              key={purchase.user_id}
              purchase={purchase}
              searchParams={searchParams}
            />,
            () => this.renderProductList(purchase)
          )
        )
      );

    return tabs;
  };

  renderProductList = (purchase) => {
    const { searchParams } = this.props;
    if (this.getActiveId() !== purchase.user_id.toString()) {
      return null;
    }

    return (
      <PurchaseProductList
        searchParams={searchParams}
        currency={purchase.currency}
        userId={purchase.user_id.toString()}
      />
    );
  };

  renderAccordionRows = () => {
    const tabs = this.getTabs();
    const activeTabId = this.getActiveId();

    return tabs.map((tab) => {
      const isOpen = activeTabId === tab.id;
      return (
        <div
          className={classNames('PurchaseList__tab', {
            'PurchaseList__tab--open': isOpen,
          })}
          key={tab.id}
        >
          <div
            className="PurchaseList__tab-toggle"
            onClick={() => this.toggleTab(tab.id)}
          >
            {tab.title}
          </div>
          <Collapse isOpen={isOpen}>
            <div className="PurchaseList__tab-content">{tab.getContent()}</div>
          </Collapse>
        </div>
      );
    });
  };

  renderPurchaseRows = () => {
    return (
      <div className="PurchaseList__tabs">{this.renderAccordionRows()}</div>
    );
  };

  render() {
    const { customerUserStore, uiStore, searchParams } = this.props;
    const purchaseList = customerUserStore.purchaseQueryResults.get(
      this.getQueryIdentifier(searchParams)
    );

    if (!purchaseList || purchaseList.purchases.length === 0) {
      return (
        <div className="PurchaseList__no_results">
          <FormattedMessage {...globalTranslations.myAccountNoPurchases} />
        </div>
      );
    }

    return (
      <div className="PurchaseList">
        {!uiStore.isMobile && this.renderHeaders()}
        {this.renderPurchaseRows()}
        <PurchaseTotal total={purchaseList.total} />
      </div>
    );
  }
}

PurchaseList.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default inject('customerUserStore', 'uiStore')(PurchaseList);
